import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import {
    BlockType,
    CodeBlock,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class Tibbit_39 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_39';
        this.name = 'Tibbit 39';

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                default: '',
                required: true,
            },
            {
                id: 'L1NAME',
                name: 'LN1 Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const name = this.getSettingValue('NAME');
        const ledIO = name.concat('_LED');
        const connectedSocket = (Number(this.getSettingValue('SOCKET')) - 1).toString();
        const state = this.getSettingValue('L1NAME');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 39 setup with 00_3
    io.num=${ledIO}
    io.state=HIGH
    io.enabled=YES`,
        });


        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${ledIO} = ${Tibbits.getSocketPins(connectedSocket, this.project.device.id)[0]}`,
        });

        blocks.push({
            location: `var_${state}_changed`,
            blockType: BlockType.CODE,
            template: `
    io.num=${ledIO}
    io.state=${state}`,
        });

        return blocks;
    }
}
